/// <reference path="../../Common/Helpers/GridEditorDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass('Matrix.Data.DataParameterDialog')
    @Serenity.Decorators.responsive()
    export class DataParameterDialog extends Common.GridEditorDialog<DataParameter> {
        protected getFormKey() { return DataParameterForm.formKey; }
        protected getNameProperty() { return "Name"; }
        protected getEntitySingular() { return "Parameter"; }

        protected form = new DataReportParameterForm(this.idPrefix);

        private editorOptions: Serenity.PropertyGrid;

        constructor() {
            super();

            this.createOptionsGrid();

            this.form.EditorType.changeSelect2(e => this.createOptionsGrid());
        }

        public loadEntity(entity: DataParameter) {
            super.loadEntity(entity);

            this.createOptionsGrid();
            this.editorOptions.load(entity.EditorParams || {});
        }

        protected getSaveEntity(): DataParameter {
            var e = super.getSaveEntity();
            e.EditorParams = {};
            this.editorOptions.save(e.EditorParams);
            return e;
        }

        private createOptionsGrid() {
            var el: JQuery;
            if (this.editorOptions) {
                el = this.editorOptions.element;
                this.editorOptions.destroy();
                this.editorOptions = null;
                el.html('');
            }
            else
                el = $('<div/>').insertAfter(this.propertyGrid.element);

            var items: Serenity.PropertyItem[];
            var editorType = this.form.EditorType.value;
            if (editorType) {
                var et = Q.getLookup<DataReportEditorTypeItem>("Data.DataReportEditorType")
                    .itemById[editorType];
                if (et)
                    items = et.Options;
            }

            items = items || [];

            var index = Q.indexOf(items, x => x.name == "lookupKey");
            if (index > 0) {
                var item = items[index];
                items.splice(index, 1);
                items.splice(0, 0, item);
            }

            this.editorOptions = new Serenity.PropertyGrid(el, {
                items: items,
                mode: Serenity.PropertyGridMode.insert,
                idPrefix: this.idPrefix + "Options_"
            });

            this.editorOptions.load({});
        }
    }
}